import dayjs from 'dayjs';
import 'dayjs/locale/uk' // load on demand

dayjs.locale('uk');

export default {
    filters: {
        dateFormat: (value) => {
            return dayjs(value).format('MMMM YYYY');
        }
    }
}